module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-3.4c7aa99a.jpg";